import { sameOriginUrl } from '../same-origin-url';

// The Stencil mock window has no page URL by default.
beforeEach(() => {
  (window as any).location = 'https://shop.test/buy';
});

describe('sameOriginUrl', () => {
  it.each([
    ['https://shop.test/thanks?sc=1#x', 'https://shop.test/thanks?sc=1#x'],
    ['/thanks', '/thanks'],
    ['thanks', 'thanks'],
    // Same-scheme without slashes is a relative reference, so it stays on-site.
    ['https:evil.example', 'https:evil.example'],
  ])('keeps a same-origin url %p', (url, expected) => {
    expect(sameOriginUrl(url)).toBe(expected);
  });

  it.each([
    ['https://evil.example/phish'],
    ['//evil.example/phish'],
    ['https://shop.test.evil.example/'],
    ['https://shop.test:8443/thanks'],
    ['http://shop.test/thanks'],
    ['http:evil.example'],
    // eslint-disable-next-line no-script-url
    ['javascript:alert(1)'],
    ['data:text/html,hi'],
  ])('refuses %p', url => {
    expect(sameOriginUrl(url)).toBeNull();
  });

  it('is null for an empty value', () => {
    expect(sameOriginUrl('')).toBeNull();
    expect(sameOriginUrl(null)).toBeNull();
    expect(sameOriginUrl(undefined)).toBeNull();
  });
});
